import PropTypes from 'prop-types';
import {Card} from '@mui/material';
import Icon from '@mui/material/Icon';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

// Inline "access denied" card for list pages: shown instead of firing a list
// request the backend would reject anyway, when the signed-in user has no
// `read` permission on the module (but may still have create/update/delete).
const NoPermissionNotice = ({title, message}) => (
  <MDBox mt={5} mb={3}>
    <Card sx={{padding: 4, textAlign: 'center'}}>
      <Icon sx={{fontSize: 48, color: 'warning.main', mb: 2}}>block</Icon>
      <MDTypography variant="h5" mb={1}>
        {title}
      </MDTypography>
      <MDTypography variant="button" color="text" display="block">
        {message}
      </MDTypography>
    </Card>
  </MDBox>
);

NoPermissionNotice.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
};

NoPermissionNotice.defaultProps = {
  title: "You don't have permission to view this",
  message:
    "Your role doesn't include read access to this module. Ask an administrator to update your permissions.",
};

export default NoPermissionNotice;
